module.exports = __webpack_public_path__ + "static/media/scales.a38f8787.svg";